import { render, staticRenderFns } from "./SetUpDialog.vue?vue&type=template&id=31f4a352&scoped=true"
import script from "./SetUpDialog.vue?vue&type=script&lang=js"
export * from "./SetUpDialog.vue?vue&type=script&lang=js"
import style0 from "./SetUpDialog.vue?vue&type=style&index=0&id=31f4a352&prod&lang=scss&scoped=true"
import style1 from "./SetUpDialog.vue?vue&type=style&index=1&id=31f4a352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4a352",
  null
  
)

export default component.exports